/**
 * Product configuration data for Desktop Station
 */
export const desktopStationConfig = {
  4: {
    slots: 4,
    gallery: [
      {
        src: "assets/images/products/original/desktop-4-slot-white-with-pos-original.png",
        srcset: "assets/images/products/original/desktop-4-slot-white-with-pos-original.png"
      },
      {
        src: "assets/images/products/desktop-8-white-bank-3x.png",
        srcset: "assets/images/products/desktop-8-white-bank-2x.png"
      },
      {
        src: "assets/images/products/powerbank-white-3x.png",
        srcset: "assets/images/products/powerbank-white-2x.png"
      }
    ]
  },
  8: {
    slots: 8,
    gallery: [
      {
        src: "assets/images/products/original/desktop-8-slot-white-with-pos-original.png",
        srcset: "assets/images/products/original/desktop-8-slot-white-with-pos-original.png"
      },
      {
        src: "assets/images/products/desktop-8-white-bank-3x.png",
        srcset: "assets/images/products/desktop-8-white-bank-2x.png"
      }
    ]
  },
  12: {
    slots: 12,
    gallery: [
      {
        src: "assets/images/products/original/desktop-12-slot-white-with-pos-original.png",
        srcset: "assets/images/products/original/desktop-12-slot-white-with-pos-original.png"
      }
    ]
  },
  16: {
    slots: 16,
    gallery: [
      {
        src: "assets/images/products/original/desktop-24-slot-white-with-pos-original.png",
        srcset: "assets/images/products/original/desktop-24-slot-white-with-pos-original.png"
      }
    ]
  }
};

/**
 * Product configuration data for Kiosk Station
 */
export const kioskStationConfig = {
  24: {
    slots: 24,
    variantName: '24-slot · 23.8" screen',
    gallery: [
      {
        src: "assets/images/products/original/desktop-24-slot-white-with-pos-original.png",
        srcset: "assets/images/products/original/desktop-24-slot-white-with-pos-original.png"
      }
    ]
  },
  48: {
    slots: 48,
    variantName: '48-slot · 43" screen',
    gallery: [
      {
        src: "assets/images/products/original/desktop-24-slot-white-with-pos-original.png",
        srcset: "assets/images/products/original/desktop-24-slot-white-with-pos-original.png"
      }
    ]
  }
};
